/**
 * Application Constants
 */

// Local Storage Keys
export const STORAGE_KEYS = {
  PREFERENCES: 'swedevtools-preferences',
  PIPELINES: 'swedevtools-pipelines',
  HISTORY: 'swedevtools-history',
  APP_STATE: 'swedevtools-app-state',
} as const;

// UI Constants
export const UI = {
  SIDEBAR_MIN_WIDTH: 240,
  SIDEBAR_MAX_WIDTH: 400,
  SIDEBAR_DEFAULT_WIDTH: 280,
  EDITOR_MIN_HEIGHT: 200,
  TOOLBAR_HEIGHT: 48,
  DEBOUNCE_DELAY: 300,
  AUTO_SAVE_INTERVAL: 5000,
} as const;

// Tool Categories
export const TOOL_CATEGORIES = [
  'JSON',
  'Encoding',
  'Hash',
  'JWT',
  'Time',
  'Text',
  'Regex Tools',
  'Generators',
  'Visualizers',
] as const;

// Keyboard Shortcuts
export const SHORTCUTS = {
  RUN_PIPELINE: 'mod+enter',
  FORMAT: 'mod+shift+f',
  SAVE_PIPELINE: 'mod+s',
  CLEAR_INPUT: 'mod+shift+c',
  TOGGLE_SIDEBAR: 'mod+b',
  SEARCH_TOOLS: 'mod+k',
} as const;

// Theme Colors
export const THEME = {
  light: {
    background: '#ffffff',
    foreground: '#020817',
    card: '#ffffff',
    border: '#e2e8f0',
    muted: '#f1f5f9',
  },
  dark: {
    background: '#020817',
    foreground: '#f8fafc',
    card: '#0f172a',
    border: '#1e293b',
    muted: '#1e293b',
  },
} as const;

// File Extensions for Import/Export
export const FILE_EXTENSIONS = {
  PIPELINE: '.swedevtools',
  JSON: '.json',
  TEXT: '.txt',
} as const;

